/**
 * 今日時〆（売上確定）API の 422 エラーレスポンス用型
 * PUT .../sales-manager/sales-confirm で errorCode + reservations が返る場合
 */
export interface SalesConfirmErrorReservation {
  reservation_id: string
  guest_name: string | null
}

export type SalesConfirmErrorCode = 'UNPAID_SALES_REMAIN' | 'DISCOUNT_SUBJECT_PAYMENT_NOT_SELECTED'

export interface SalesConfirmErrorResponse {
  errorCode: SalesConfirmErrorCode
  mustShow?: boolean
  reservations: SalesConfirmErrorReservation[]
}

export const isSalesConfirmErrorResponse = (data: unknown): data is SalesConfirmErrorResponse =>
  typeof data === 'object' &&
  data !== null &&
  typeof (data as SalesConfirmErrorResponse).errorCode === 'string' &&
  Array.isArray((data as SalesConfirmErrorResponse).reservations)
